import { render, staticRenderFns } from "./RelatorioGestaoPcaNaturezaDespesa.vue?vue&type=template&id=53af734e"
import script from "./RelatorioGestaoPcaNaturezaDespesa.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaNaturezaDespesa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports